import React, { useContext } from 'react';
import c from 'classnames';
import { LoadableComponentContext } from '@wix/da-hooks/pkg/useLoadableComponent';
import ElementQueries from '../../../ElementQueries';
import { CommentEditorContext } from '../../../CommentEditor/context';
import { setRefs } from '../../../utils/refHelpers';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import s from './CommentBoxRoot.scss';
/**
 * The top component in our CommentBox tree.
 *
 * Provides an ElementsQueries component and disables theme skinning.
 */ const CommentBoxRoot = /*#__PURE__*/ React.forwardRef(({ children, className, isSmall }, ref)=>{
    const { editorId, isExpanded, rootElementRef } = useContext(CommentEditorContext);
    const { isLoadingTriggered } = useContext(LoadableComponentContext);
    return /*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "CommentBoxRoot"
    }, /*#__PURE__*/ React.createElement(ElementQueries, {
        id: editorId,
        // Whenever the comment box is collapsed, we need a place to put focus that isn't a now-hidden element. Following
        // popup logic and dropping focus back to the containing element
        tabIndex: -1,
        className: c('no-theme-skin', s['commentbox'], isExpanded && s['expanded'], isSmall && !(isExpanded || isLoadingTriggered) && 'small-editor', className),
        forwardedRef: (node)=>setRefs([
                ref,
                rootElementRef
            ], node),
        widthBreakpoints: [
            490
        ]
    }, children));
});
CommentBoxRoot.displayName = 'CommentBoxRoot';
export default CommentBoxRoot;

//# sourceMappingURL=CommentBoxRoot.js.map